import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { FiSearch } from 'react-icons/fi';
import { TiArrowRightThick, TiArrowLeftThick } from 'react-icons/ti';
import ReactPaginate from 'react-paginate';

import { handleGetStudents } from '../../../../store/actionCreators/students';

class Students extends Component {
    state = {
        getError: {
            state: false,
            message: ""
        },
        currentPage: 0
    }

    componentDidMount() {
        this.props.dispatch(handleGetStudents(this.props.match.params.id))
        .then(result => {
            if (result.error && result.error !== null) {
                this.setState({
                    getError: {
                        state: true,
                        message: result.error.message
                    }
                })
            } else {
            }
        })
    }

    handlePageClick = ({ selected: selectedPage }) => {
        this.setState({ currentPage: selectedPage })
    }
    
    render() {
        console.log(this.state);
        const offset = this.state.currentPage * 12;
        if (this.props.students && this.props.students !== null) {
            return (
                <div className="p-2 p-lg-4 all-unis flex-grow-1">
                    <div className="pt-2 pb-2 px-3 my-1 my-lg-4 clearfix header-rec">
                        <h1 className="float-end">الطلبة المشتركين</h1>
                        <h1 className="float-start">3212</h1>
                    </div>
                    <div className="px-4">
                        <div className="position-relative">
                            <input type="text" className="search-input" placeholder="البحث بواسطة اسم الطالب المشترك أو رقم هاتفه" />
                            <FiSearch className="search-icon" color="rgb(50,157,135)" size="2rem" />
                        </div>
                    </div>
                    <div className="d-flex my-4 flex-wrap px-1 px-lg-3 align-content-start w-100" style={{minHeight: "376px"}}>
                        {this.props.students.slice(offset, offset + 12).map(student =>
                            <div className="student-box p-3 m-1" key={student._id}>
                                <img className="mb-3" src={(student.profile_photo === null || student.profile_photo === "") ? "/images/user-profile-placeholder-image.png" : student.profile_photo} alt="طالب" width="70" height="70" />
                                <h6>{student.name}</h6>
                                <h6 className="text-end" style={{direction: "ltr"}}>{student.phone}</h6>
                            </div>
                        )}
                    </div>
                    <div>
                        <ReactPaginate
                            pageCount={this.props.students.length/12}
                            previousLabel={<TiArrowRightThick className="pagination__arrow-icons" size="2.3rem" color="rgb(52, 124, 226)" />}
                            nextLabel={<TiArrowLeftThick className="pagination__arrow-icons" size="2.3rem" color="rgb(52, 124, 226)" />}
                            pageClassName="page-item"
                            pageLinkClassName="page-link"
                            breakLabel={'......'}
                            breakClassName={'break-me'}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            containerClassName={'pagination p-0 justify-content-center align-items-center flex-wrap flex-lg-nowrap'}
                            activeClassName={'pagination__active'}
                            onPageChange={this.handlePageClick}
                            disabledClassName={"pagination__disabled"}
                        />
                    </div>
                </div>
            )
        } else {
            if (this.state.getError.state) {
                return (
                    <div className="m-5">
                        <div className="alert alert-danger text-center mb-5 fs-5" role="alert">
                            {this.state.getError.message}
                        </div>
                    </div>
                )
            } else {
                return (
                    <div className="text-center m-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                )
            }
        }
    }
}

function mapStateToProps ({ students }) {
	return {
		students
	}
}

export default withRouter(connect(mapStateToProps)(Students));